import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { ICreatePasswordData } from 'api/types/password';
import type { IRequestException } from 'api/types/requestException';
import type { IUser } from 'api/types/user';

const createPassword = async ({
    emailToken,
    password,
}: ICreatePasswordData) => {
    const response = await apiClient.post('users', {
        json: {
            emailToken,
            password,
        },
    });

    return (await response.json()) as IUser;
};

export const useCreatePasswordMutation = (
    options: UseMutationOptions<IUser, IRequestException, ICreatePasswordData>
) => {
    return useMutation(async (props) => await createPassword(props), options);
};
